
import { AxiosClient } from "../utils/axios";

export default {
  name: "SearchSchoolBanner",
  data() {
    return {
      BASE_URL_STATIC: this.$config.BASE_URL_STATIC,
      BASE_URL_RESOURCE: this.$config.BASE_URL_RESOURCE,
      searchQuery: "",
      suggestionList: [],
      showSuggestions: false,
      selectedIndex: -1,
      loading: false,
      debounceTimer: null,
    };
  },
  methods: {
    handleInput() {
      this.selectedIndex = -1;
      if (!this.searchQuery.trim()) {
        this.showSuggestions = false;
        this.suggestionList = [];
        return;
      }
      this.debouncedSearch();
    },
    debouncedSearch() {
      if (this.debounceTimer) {
        clearTimeout(this.debounceTimer);
      }
      this.debounceTimer = setTimeout(() => {
        this.fetchSuggestions();
      }, 300);
    },
    async fetchSuggestions() {
      if (!this.searchQuery.trim()) {
        this.suggestionList = [];
        return;
      }

      try {
        this.loading = true;
        const response = await AxiosClient.get("/eduzone/api/ls", {
          params: {
            page: 1,
            page_size: 10,
            name: this.searchQuery,
          },
        });

        this.suggestionList = response.data?.data || [];
        this.showSuggestions = true;
      } catch (error) {
        console.error("Error fetching schools:", error);
        this.suggestionList = [];
      } finally {
        this.loading = false;
      }
    },
    handleKeydown(e) {
      if (!this.showSuggestions || this.suggestionList.length === 0) return;

      switch (e.key) {
        case "ArrowDown":
          e.preventDefault();
          if (this.selectedIndex < this.suggestionList.length - 1) {
            this.selectedIndex++;
          }
          break;
        case "ArrowUp":
          e.preventDefault();
          if (this.selectedIndex > 0) {
            this.selectedIndex--;
          }
          break;
        case "Enter":
          e.preventDefault();
          if (this.selectedIndex >= 0) {
            this.selectSchool(this.suggestionList[this.selectedIndex]);
          } else if (this.suggestionList.length > 0) {
            // Nếu không select cái nào, lấy cái đầu tiên
            this.selectSchool(this.suggestionList[0]);
          }
          break;
        case "Escape":
          this.showSuggestions = false;
          break;
      }
    },
    onSearch() {
      // Khi user click search button hoặc enter từ input
      if (this.suggestionList.length > 0) {
        this.selectSchool(this.suggestionList[0]);
      }
    },
    selectSchool(school) {
      if (school && school.id) {
        // Đóng suggestions
        this.showSuggestions = false;
        this.searchQuery = "";

        // Navigate tới school detail
        this.$router.push(`/school/${school.id}`);

        // Emit event nếu parent component cần biết
        this.$emit("school-selected", school);
      }
    },
    handleImageError(e) {
      e.target.style.display = "none";
    },
  },
  watch: {
    showSuggestions(newVal) {
      if (newVal) {
        // Reset selected index khi show suggestions
        this.selectedIndex = -1;
      }
    },
  },
};
